import { render, staticRenderFns } from "./KeySettings.vue?vue&type=template&id=a8f76280"
import script from "./KeySettings.vue?vue&type=script&lang=js"
export * from "./KeySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports